import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { actions } from 'src/actions';
import { EmailStage, SequencesSearchSettings } from 'src/types';

export type State = {
  data?: EmailStage[];
  count: number;
  searchSettings?: SequencesSearchSettings;
};

const initialState: State = {
  data: [],
  count: 0,
  searchSettings: {
    searchWord: '',
    limitElements: 20,
    currentPage: 1,
    hideSevaSequences: false,
  },
};

const reducer = reducerWithInitialState<State>(initialState)
  .cases(
    [actions.api.sequences.get.done],
    (state, payload): State => ({
      ...state,
      data: payload.result.result,
      count: payload.result.count,
    })
  )
  .cases(
    [actions.ui.sequences.setSearchSettings],
    (state, payload): State => ({
      ...state,
      searchSettings: {
        ...state.searchSettings,
        ...payload,
      },
    })
  );

export const sequences = { reducer, initialState }; 